import React, { Suspense, useEffect, useState } from 'react';
import Loader from 'src/components/Loader/Loader';
import ErrorBoundary from 'src/components/Errors/ErrorBoundary';
import {
  defaultVortexConfiguration,
  FusionPreview,
  PreviewSettings,
  VortexConfiguration,
  PreviewPosition,
} from '@dexter/fusion-preview';
import { CimpressDocument } from '@mcp-artwork/cimdoc-types-v2';
import 'src/components/Preview3DApp/common/Preview3DApp.scss';
import { loadLocalization } from 'src/common';
import { enUS, Localization } from '@dexter/print-extended';
import type { FusionPreviewLocalization } from '@dexter/fusion-preview';

declare const window: any;
const accessToken = window.anonToken;

const tenantId = process.env.REACT_APP_TENANT_ID;

const vortexConfig: VortexConfiguration = {
  ...defaultVortexConfiguration,
  loader: <Loader />,
};

vortexConfig.successCallback = success => {
  window.EventBus.$emit('vortexSuccessLoad', success);
};

const App = (props: { options: any }) => {
  const cimDoc: CimpressDocument = props.options.cimDoc;

  const { LEFT, BOTTOM } = PreviewPosition;
  const previewPosition =
    props.options?.thumbnailsPosition === 'bottom' ? BOTTOM : LEFT;
  const vortex = props.options?.vortex ?? true;
  const enableFlipBook = props.options?.enableFlipBook ?? false;
  const vortexConfigOverride = props.options?.vortexConfig ?? {};
  Object.assign(vortexConfig, vortexConfigOverride);

  const scene = props.options?.scene ?? true;
  const flatPreview = props.options?.flatPreview ?? true;
  const enablePackagingFlatPreview =
    props.options?.enablePackagingFlatPreview ?? false;

  const skuAndAttributes = {
    attributes: props.options.skuVariables,
    sku: props.options.mcpSku,
  };

  const previewSettings: PreviewSettings = {
    vortex,
    scene,
    flatPreview,
    enablePackagingFlatPreview,
    position: previewPosition,
    enableFlipBook,
  };

  const [localization, setLocalization] = useState<FusionPreviewLocalization>();

  // Load the Preview3DApp style by tenant
  useEffect(() => {
    import(`/${tenantId}/Preview3DApp.scss`);
  }, []);

  // localization based on files
  useEffect(() => {
    loadLocalization('print-extended-dex', props.options.locale ?? 'en-gb').then(
      (localizedContent: Localization) => {
        setLocalization({
          actionButtonLabels: {
            ...enUS.fusionPreview.actionButtonLabels, // fallback in case some values are missing?
            ...localizedContent?.fusionPreview.actionButtonLabels,
          },
        });
      }
    );
  }, [props.options.locale]);

  return localization ? (
    <div className="threeDPreviewApp">
      <ErrorBoundary locale={props.options.locale}>
        <Suspense fallback={<Loader />}>
          <FusionPreview
            isResponsive={false}
            authToken={accessToken}
            cimDoc={cimDoc}
            productConfiguration={skuAndAttributes}
            previewSettings={previewSettings}
            localization={localization}
            vortexConfiguration={vortexConfig}
          />
        </Suspense>
      </ErrorBoundary>
    </div>
  ) : (
    <div></div>
  );
};

export default App;
